import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {BaseLogAction} from '../common/base-log-action';

/**
 * This component renders a task log for a `remove` action.
 *
 * @example
 * ```txt
 * John Doe desfez a tarefa                  2025/01/01 às 15:00:00
 * ```
 */
export function TaskLogRemoveAction({
  name,
  picture,
  date,
  compactDisplay,
  ...rest
}: {
  name: string;
  picture?: string;
  date?: string;
  compactDisplay?: boolean;
  key?: string;
}) {
  const {t} = useTranslation();

  return (
    <BaseLogAction
      title={name + ' ' + t(translations.care_and_activities.handle_task_modal.history.remove)}
      name={name}
      picture={picture}
      date={date}
      compactDisplay={compactDisplay}
      {...rest}
    />
  );
}
